import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useStyles from "./calendar-toolbar.style";
import CalendarToday from "@iconify/icons-mdi/calendar-today";
import ChevronLeft from "@iconify/icons-mdi/chevron-left";
import ChevronRight from "@iconify/icons-mdi/chevron-right";
import ViewDayOutline from "@iconify/icons-mdi/view-day-outline";
import ViewModuleOutline from "@iconify/icons-mdi/view-module-outline";
import ViewSequentialOutline from "@iconify/icons-mdi/view-sequential-outline";
import ViewStreamOutline from "@iconify/icons-mdi/view-stream-outline";
import { InlineIcon } from "@iconify/react";

interface MyLeaveCalendarToolbarProps {
  view: string;
  onView: (view: string) => void;
  onNavigate: (action: string) => void;
  date: Date | string;
  monthFiltering: boolean;
  setToolbarButton: (button: string) => void;
  handleButtonChange: (button: number) => void;
}

export const MyLeaveCalendarToolbar = (props: MyLeaveCalendarToolbarProps) => {
  const { i18n } = useTranslation();
  let {
    view,
    onView,
    onNavigate,
    date,
    monthFiltering,
    setToolbarButton,
    handleButtonChange,
  } = props;
  let title = moment(date).locale(i18n.language).format("YYYY. MMMM");
  const iconSize = 30;

  if (view === "weeklyTimeline") {
    let start = moment(date)
      .locale(i18n.language)
      .startOf("week")
      .format("YYYY.MM.D");
    let end = moment(date)
      .locale(i18n.language)
      .endOf("week")
      .format("YYYY.MM.D");
    if (i18n.language !== "hu") {
      start = moment(date)
        .locale(i18n.language)
        .startOf("week")
        .format("DD/MM/YYYY");
      end = moment(date)
        .locale(i18n.language)
        .endOf("week")
        .format("DD/MM/YYYY");
    }
    title = `${start} - ${end}.`;
  }
  /*if (view === "agenda") {
    let start = moment(date).locale(i18n.language).format("YYYY.MM.D.");
    let end = moment(date).add(30, "days").format("YYYY.MM.D.");
    if (i18n.language !== "hu") {
      start = moment(date)
        .locale(i18n.language)
        .startOf("week")
        .format("DD/MM/YYYY");
      end = moment(date)
        .locale(i18n.language)
        .endOf("week")
        .format("DD/MM/YYYY");
    }

    title = `${start} - ${end}`;
  }*/

  const classes = useStyles({ monthFiltering });

  return (
    <div className={classes.toolbarMainContainer}>
      {!monthFiltering && (
        <div className={classes.centerContainer}>
          <InlineIcon
            icon={ChevronLeft}
            width={iconSize}
            height={iconSize}
            className={classes.leftChevron}
            onClick={() => onNavigate("PREV")}
          />
          <span className={classes.title}>{title}</span>
          <InlineIcon
            icon={ChevronRight}
            width={iconSize}
            height={iconSize}
            className={classes.rightChevron}
            onClick={() => onNavigate("NEXT")}
          />
        </div>
      )}
      <div
        style={{
          paddingTop: 2,
        }}
      >
        <InlineIcon
          icon={CalendarToday}
          width={iconSize}
          height={iconSize}
          onClick={() => onNavigate("TODAY")}
          className={view !== "day" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <div style={{ display: "inline-block", width: 24, height: 24 }}></div>
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewModuleOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("month")}
          className={view !== "month" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewSequentialOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("timeline")}
          className={view !== "timeline" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewStreamOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("weeklyTimeline")}
          className={
            view !== "weeklyTimeline" ? classes.icon : classes.iconDisabled
          }
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewDayOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => {
            setToolbarButton("dailyTable");
            handleButtonChange(1);
          }}
          className={classes.icon}
        />
      </div>
    </div>
  );
};

export default MyLeaveCalendarToolbar;
